import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var OfflineShare = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5H4v18h12v-2H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 1H8v18h12V1zm-2 14h-8V5h8v10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.25h2V12L17 9.5 14.5 7v1.75H11V12h1.5z"
  }));
});
OfflineShare.displayName = 'OfflineShare';
export var OfflineShareDimensions = {
  height: 24,
  width: 24
};